<div class="solution-card" [class.is-highlighted]="isHighlighted()">
  <div class="icon-container">
    <tlc-churn-flow-solution-icon [variant]="iconVariant()" />
  </div>

  <span class="title">{{ title() }}</span>
  @if (subtitle()) {
    <span class="subtitle">{{ subtitle() }}</span>
  }

  @if (displayFreeBadge()) {
    <rt-badge [text]="'tlc.churn_flow.common.free' | translate" color="success-tint" />
  }

  <ng-content select=".additional-content-top" />

  <div class="incentives-container">
    @for (incentive of incentives(); track $index) {
      <div class="incentive">
        <rt-icon name="check" colorToken="colorIconSuccessDefault" />
        <span class="text">{{ incentive }}</span>
      </div>
    }
  </div>

  <ng-content select=".additional-content-bottom" />

  <div class="actions-container">
    <ng-content select=".actions" />
  </div>
</div>
